export const CF_TOKEN_FIELD_NAME = "cfToken";
export const CF_TOKEN_HEADER_NAME = "h-captcha-response";

export const CAPTCHA_TYPE = {
  CLOUDFLARE: "CLOUDFLARE",
  GOOGLE: "GOOGLE"
}

